// Link do código do regex: https://regexr.com/2ri2c
const PATTERN_EMAIL = /\b[\w.-]+@[\w.-]+\.\w{2,4}\b/gi;
const NAME_LENGTH = 3;

export {
  PATTERN_EMAIL,
  NAME_LENGTH,
};
